import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var BatchTextureArray = /*#__PURE__*/function () {
  function BatchTextureArray() {
    _classCallCheck(this, BatchTextureArray);
    this.elements = [];
    this.ids = [];
    this.count = 0;
  }
  _createClass(BatchTextureArray, [{
    key: "clear",
    value: function clear() {
      for (var i = 0; i < this.count; i++) {
        this.elements[i] = null;
      }
      this.count = 0;
    }
  }]);
  return BatchTextureArray;
}();
export { BatchTextureArray };